export class Cookies {
	private static _value = document.cookie.replace(' ', '');

	static get value(): string {
		return this._value;
	}

	static getAll(): Record<string, string> {
		return this.toRecord();
	}

	static get(v: string): string | null {
		return this.toRecord()[v];
	}

	static set(key: string, value: string, options: Record<string, any> = {}): void {
		let cookieString = `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;

		if (options.expires) {
			const expires = options.expires instanceof Date
				? options.expires.toUTCString()
				: options.expires;
			cookieString += `; expires=${expires}`;
		}

		if (options.path) cookieString += `; path=${options.path}`;
		if (options.domain) cookieString += `; domain=${options.domain}`;
		if (options.secure) cookieString += `; secure`;
		if (options.sameSite) cookieString += `; samesite=${options.sameSite}`;

		document.cookie = cookieString;

		// Update the static _value
		this._value = document.cookie.replace(' ', '');
	}

	private static toRecord() {
		return Object.fromEntries(
			this._value
				.split(';')
				.map(keypair => keypair.split('=').map(v => v.trim()))
		);
	}
}
